import { Box, Stack, Typography } from '@mui/material';
import { SignedRecordSectionModel } from '../../domain/signedControlRecord/recordDetailAdapter';
import { SignedSafetyControlRecord } from '../../services/reportsApi';
import { SignedRecordSectionNav, SignedRecordSections } from './SignedRecordSections';

export function NativeDetailedRecord({
  sections,
  record,
  orgId,
  siteId,
}: {
  sections: SignedRecordSectionModel[];
  record: SignedSafetyControlRecord;
  orgId?: string | null;
  siteId?: string | null;
}) {
  return (
    <Box
      component="section"
      aria-labelledby="native-detailed-record-heading"
      data-testid="native-detailed-record"
      sx={{
        pt: { xs: 2, md: 4 },
        borderTop: '1px solid rgba(8,27,51,0.22)',
      }}
    >
      <Typography
        variant="overline"
        sx={{ color: '#087fa5', letterSpacing: '0.16em', fontWeight: 800 }}
      >
        Canonical signed record
      </Typography>
      <Typography
        id="native-detailed-record-heading"
        component="h2"
        sx={{ mt: 0.5, fontSize: { xs: '1.8rem', md: '2.6rem' }, fontWeight: 800 }}
      >
        Signed record detail
      </Typography>
      <Typography color="text.secondary" sx={{ mt: 0.75, mb: 2.5, maxWidth: 760 }}>
        Native browser view of the immutable signed facts for this exact Signed revision.
      </Typography>
      <Stack spacing={{ xs: 2.5, md: 3.5 }}>
        <SignedRecordSectionNav sections={sections} />
        <SignedRecordSections
          sections={sections}
          record={record}
          orgId={orgId}
          siteId={siteId}
        />
      </Stack>
    </Box>
  );
}
